"use strict";
/**
 * This is a shim for delegating the public path to the federator at runtime.
 * It allow federated apps to use split chunks for async modules.
 * @see https://webpack.js.org/guides/public-path/#on-the-fly
 *
 * It loads the module's metadata from the global scope and uses `metadata.root`
 * as the base for any dynamically fetched files; `root` is the parent directory
 * of the main entry file (not the remote's hostname) since remotes are keyed by
 * git sha.
 */
/* eslint-disable */
var modules = (window[Symbol.for('@ally/federator')] || {}).modules;
var module = (modules && modules.get(APP_BUILD_INFO.name)) || {};
var root = (module.meta || {}).root;
var base = root ? root.replace(/\/$/, '') + '/' : '';
__webpack_public_path__ = base + __webpack_public_path__;
//# sourceMappingURL=remote-public-path-shim.js.map